<template>
  <v-dialog v-model="dialog" width="900" :persistent="true">
    <v-card>
      <v-toolbar card dark color="primary">
        <v-toolbar-title>
          {{ `app.ksef.ksef_details` | trans }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark small @click="close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-container>
          <v-layout wrap>
            <v-flex xs6>
              <span class="subheading">{{ `app.ksef.details.tracking_id` | trans }}:</span>
            </v-flex>
            <v-flex xs6>
              <span>{{ ksef.tracking_id }}</span>
            </v-flex>
            <v-flex xs6>
              <span class="subheading">{{ `app.ksef.details.sent_at` | trans }}:</span>
            </v-flex>
            <v-flex xs6>
              <span v-if="ksef.sent_at">{{ ksef.sent_at | format_date(FORMAT_DATETIME_SECONDS()) }}</span>
              <span v-else>-</span>
            </v-flex>
            <v-flex xs6>
              <span class="subheading">{{ `app.ksef.details.processed_at` | trans }}:</span>
            </v-flex>
            <v-flex xs6>
              <span v-if="ksef.processed_at">{{ ksef.processed_at | format_date(FORMAT_DATETIME_SECONDS()) }}</span>
              <span v-else>-</span>
            </v-flex>
            <v-flex xs6>
              <span class="subheading">{{ `app.ksef.details.offline_mode` | trans }}:</span>
            </v-flex>
            <v-flex xs6>
              <span>{{ ksef.offline_mode ? `app.yes` : `app.no` | trans }}</span>
            </v-flex>
            <v-flex xs6>
              <span class="subheading">{{ `app.ksef.details.ksef_number` | trans }}:</span>
            </v-flex>
            <v-flex xs6>
              <span v-if="ksef.ksef_number">{{ ksef.ksef_number }}</span>
              <span v-else>-</span>
            </v-flex>
            <v-flex xs6>
              <span class="subheading">{{ `app.ksef.details.invoice_reference_number` | trans }}:</span>
            </v-flex>
            <v-flex xs6>
              <span v-if="ksef.invoice_reference_number">{{ ksef.invoice_reference_number }}</span>
              <span v-else>-</span>
            </v-flex>
            <v-flex xs6>
              <span class="subheading">{{ `app.ksef.details.session_reference_number` | trans }}:</span>
            </v-flex>
            <v-flex xs6>
              <span v-if="ksef.session_reference_number">{{ ksef.session_reference_number }}</span>
              <span v-else>-</span>
            </v-flex>
            <v-flex xs6>
              <span class="subheading">{{ `app.ksef.ksef_status` | trans }}:</span>
            </v-flex>
            <v-flex xs6>
              <span>{{ trans('app.ksef.ksef_statuses.' + ksef.status) }}</span>
            </v-flex>
            <v-flex xs6>
              <span class="subheading">{{ `app.ksef.details.ksef_status_code` | trans }}:</span>
            </v-flex>
            <v-flex xs6>
              <span v-if="ksef.ksef_status_code">{{ ksef.ksef_status_code }}</span>
              <span v-else>-</span>
            </v-flex>
            <v-flex xs6>
              <span class="subheading">{{ `app.ksef.details.ksef_status_description` | trans }}:</span>
            </v-flex>
            <v-flex xs6>
              <span v-if="ksef.ksef_status.description">{{ ksef.ksef_status.description }}</span>
              <span v-else>-</span>
            </v-flex>
            <v-flex xs12 v-if="ksef.ksef_status.details.length > 0">
              <span class="subheading">{{ `app.ksef.details.ksef_status_details` | trans }}:</span>
              <ul>
                <li v-for="(details, index) in ksef.ksef_status.details" :key="index">
                  {{ details }}
                </li>
              </ul>
            </v-flex>
            <v-flex xs6>
              <span class="subheading">{{ `app.ksef.details.upo_xml_downloaded_at` | trans }}:</span>
            </v-flex>
            <v-flex xs6>
              <span v-if="ksef.upo_xml_downloaded_at">{{
                  ksef.upo_xml_downloaded_at | format_date(FORMAT_DATETIME_SECONDS())
                }}</span>
              <span v-else>-</span>
            </v-flex>
            <v-flex xs12>
              <span class="subheading">{{ `app.ksef.details.errors` | trans }}:</span>
              <ul class="errors-list">
                <li v-for="(error, index) in ksef.errors" :key="index">
                   [{{ error.occurred_at | format_date(FORMAT_DATETIME_SECONDS())}}] {{ error.error }}
                </li>
              </ul>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from "axios";
import {FORMAT_DATETIME_SECONDS} from "../../../utils/dateFormatter";

export default {
  data: () => ({
    dialog: false,
    ksef: {
      tracking_id: null,
      ksef_number: null,
      invoice_reference_number: null,
      session_reference_number: null,
      status: null,
      offline_mode: false,
      ksef_status_code: null,
      ksef_status: {
        details: [],
        description: null
      },
      sent_at: null,
      processed_at: null,
      upo_xml_downloaded_at: null,
      errors: [],
    }
  }),
  methods: {
    FORMAT_DATETIME_SECONDS() {
      return FORMAT_DATETIME_SECONDS
    },
    open(orderUuid) {
      axios.get('/administrator/orders/' + orderUuid + '/ksef-invoice').then((response) => {
        const ksefInvoice = response.data.data;
        const responseKsefStatus = ksefInvoice.ksef_status
        const details = responseKsefStatus !== null ? responseKsefStatus.details : [];
        this.ksef = {
          tracking_id: ksefInvoice.tracking_id,
          ksef_number: ksefInvoice.ksef_number,
          invoice_reference_number: ksefInvoice.invoice_reference_number,
          session_reference_number: ksefInvoice.session_reference_number,
          status: ksefInvoice.status,
          offline_mode: ksefInvoice.offline_mode,
          ksef_status_code: ksefInvoice.ksef_status_code,
          ksef_status: {
            details: details !== null ? details : [],
            description: responseKsefStatus !== null ? responseKsefStatus.description : null,
          },
          sent_at: ksefInvoice.sent_at,
          processed_at: ksefInvoice.processed_at,
          upo_xml_downloaded_at: ksefInvoice.upo_xml_downloaded_at,
          errors: ksefInvoice.errors,
        }
      }).catch((error) => {
        this.sentryCaptureException(error);
      });
      this.dialog = true;
    },
    close() {
      this.ksef = {
        tracking_id: null,
        ksef_number: null,
        invoice_reference_number: null,
        session_reference_number: null,
        status: null,
        offline_mode: false,
        ksef_status_code: null,
        ksef_status: {
          details: [],
          description: null
        },
        sent_at: null,
        processed_at: null,
        upo_xml_downloaded_at: null,
        errors: []
      }
      this.dialog = false;
    },
  }
}
</script>
<style scoped>
.errors-list {
  max-height: 300px;
  overflow-y: auto;
  /* Optional: adds a border so you can see the container limits */
  list-style-type: none;
}
</style>
